type SVGIconType = {
  GlobalSearchIcon: JSX.Element;
  GlobalFilter: JSX.Element;
  GlobalDownArrow: JSX.Element;
  GlobalUpArrow: JSX.Element;
  ItemsUMOSetUp: JSX.Element;
  URLAddBtn: JSX.Element;
  ModalUploadFile: JSX.Element;
  UpcScanner: JSX.Element;
  ScannerSuccessLogo: JSX.Element;
  RoundTik: JSX.Element;
  WatchIcon: JSX.Element;
  EnterIcon: JSX.Element;
  RoundIcon: JSX.Element;
  ArrowReturnLeft: JSX.Element;
  ScannerWarningLogo: JSX.Element;
  RedirectIcon: JSX.Element;
  getProgressCircle: (total:any,achived:any) => JSX.Element;
};

const ModalUploadFile = (
  <svg
    width="29"
    height="31"
    viewBox="0 0 29 31"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M16.2969 14.3718C16.3003 14.4166 16.3021 14.4618 16.3022 14.5075L16.3284 28.8234C16.3302 29.8112 15.5318 30.6143 14.5422 30.6161C13.5526 30.618 12.7512 29.8177 12.7494 28.8299L12.7232 14.5145L8.43433 17.7431C7.64447 18.3404 6.52216 18.1797 5.92839 17.3898C5.33283 16.5999 5.49183 15.4776 6.2817 14.8838L13.4298 9.50227C13.7461 9.26369 14.1253 9.1431 14.5029 9.1424C14.8625 9.14175 15.2224 9.25025 15.5324 9.46621L22.6996 14.4887C23.5095 15.0563 23.7066 16.1726 23.139 16.9807C22.5714 17.7906 21.4569 17.9877 20.647 17.4201L16.2969 14.3718Z"
      fill="#8B909D"
    />
    <path
      d="M25.2332 5.54362L25.23 3.75413L3.75609 3.79348L3.75937 5.58296C3.76117 6.56718 2.95737 7.37393 1.97316 7.37573C0.988936 7.37753 0.182191 6.57374 0.180388 5.58952L0.173831 2.01054C0.172028 1.02632 0.975823 0.21958 1.96004 0.217777L27.0129 0.171878C27.9971 0.170075 28.8039 0.973869 28.8057 1.95809L28.8122 5.53707C28.814 6.52128 28.0102 7.32803 27.026 7.32983C26.0418 7.33164 25.235 6.52784 25.2332 5.54362Z"
      fill="#8B909D"
    />
    <path
      d="M16.2969 14.3718C16.3003 14.4166 16.3021 14.4618 16.3022 14.5075L16.3284 28.8234C16.3302 29.8112 15.5318 30.6143 14.5422 30.6161C13.5526 30.618 12.7512 29.8177 12.7494 28.8299L12.7232 14.5145L8.43433 17.7431C7.64447 18.3404 6.52216 18.1797 5.92839 17.3898C5.33283 16.5999 5.49183 15.4776 6.2817 14.8838L13.4298 9.50227C13.7461 9.26369 14.1253 9.1431 14.5029 9.1424C14.8625 9.14175 15.2224 9.25025 15.5324 9.46621L22.6996 14.4887C23.5095 15.0563 23.7066 16.1726 23.139 16.9807C22.5714 17.7906 21.4569 17.9877 20.647 17.4201L16.2969 14.3718Z"
      fill="#8B909D"
    />
    <path
      d="M25.2332 5.54362L25.23 3.75413L3.75609 3.79348L3.75937 5.58296C3.76117 6.56718 2.95737 7.37393 1.97316 7.37573C0.988936 7.37753 0.182191 6.57374 0.180388 5.58952L0.173831 2.01054C0.172028 1.02632 0.975823 0.21958 1.96004 0.217777L27.0129 0.171878C27.9971 0.170075 28.8039 0.973869 28.8057 1.95809L28.8122 5.53707C28.814 6.52128 28.0102 7.32803 27.026 7.32983C26.0418 7.33164 25.235 6.52784 25.2332 5.54362Z"
      fill="#8B909D"
    />
  </svg>
);
const GlobalSearchIcon = (
  <svg
    width="18"
    height="18"
    viewBox="0 0 18 18"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M2 8C2 4.691 4.691 2 8 2C11.309 2 14 4.691 14 8C14 11.309 11.309 14 8 14C4.691 14 2 11.309 2 8M17.707 16.293L14.312 12.897C15.365 11.543 16 9.846 16 8C16 3.589 12.411 0 8 0C3.589 0 0 3.589 0 8C0 12.411 3.589 16 8 16C9.846 16 11.543 15.365 12.897 14.312L16.293 17.707C16.488 17.902 16.744 18 17 18C17.256 18 17.512 17.902 17.707 17.707C18.098 17.316 18.098 16.684 17.707 16.293"
      fill="#222B45"
    />
  </svg>
);

const GlobalFilter = (
  <svg
    width="18"
    height="18"
    viewBox="0 0 18 18"
    fill="none"
    xmlns="
http://www.w3.org/2000/svg"
  >
    <path
      d="M7.02508 14.7936L7.02523 14.7937L9.36888 16.2696C9.36892 16.2697 9.36895 16.2697 9.36898 16.2697C9.83608 16.5639 10.3846 16.5566 10.8114 16.3581C11.241 16.1584 11.625 15.7207 11.625 15.1166V8.54141L16.7951 3.88773C17.2729 3.45768 17.3574 2.83036 17.1266 2.32791C16.9011 1.83731 16.3977 1.49998 15.7962 1.49998H2.20394C1.60322 1.49998 1.09989 1.83692 0.874078 2.32682C0.642433 2.82937 0.72659 3.4571 1.20501 3.88771C1.20502 3.88772 1.20504 3.88773 1.20505 3.88775L6.375 8.5414V13.6406C6.375 14.1273 6.63902 14.5503 7.02508 14.7936Z"
      stroke="#222B45"
      strokeWidth="1.5"
    />
  </svg>
);

const GlobalDownArrow = (
  <svg
    width="16"
    height="17"
    viewBox="0 0 16 17"
    fill="none"
    xmlns="
http://www.w3.org/2000/svg"
  >
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M7.00289 9.07659C7.00097 9.05131 7 9.02577 7 9V1C7 0.448 7.447 0 8 0C8.553 0 9 0.448 9 1V9C9 9.00026 9 9.00053 9 9.00079L11.4002 7.20081C11.8422 6.86781 12.4692 6.95881 12.8002 7.40081C13.1322 7.84281 13.0422 8.46981 12.6002 8.80081L8.60021 11.8008C8.42321 11.9338 8.21121 12.0008 8.00021 12.0008C7.79921 12.0008 7.59821 11.9398 7.42521 11.8188L3.42521 9.00481C2.97321 8.68681 2.86421 8.06281 3.18221 7.61181C3.50021 7.15981 4.12321 7.05081 4.57521 7.36881L7.00289 9.07659ZM2 14V15H14V14C14 13.45 14.45 13 15 13C15.55 13 16 13.45 16 14V16C16 16.55 15.55 17 15 17H1C0.45 17 0 16.55 0 16V14C0 13.45 0.45 13 1 13C1.55 13 2 13.45 2 14Z"
      fill="#222B45"
    />
  </svg>
);
const GlobalUpArrow = (
  <svg
    width="16"
    height="17"
    viewBox="0 0 16 17"
    fill="none"
    xmlns="
    http://www.w3.org/2000/svg"
  >
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M1 0H15C15.55 0 16 0.45 16 1V3C16 3.55 15.55 4 15 4C14.45 4 14 3.55 14 3V2H2V3C2 3.55 1.55 4 1 4C0.45 4 0 3.55 0 3V1C0 0.45 0.45 0 1 0ZM4.001 10C3.696 10 3.397 9.862 3.2 9.6C2.868 9.158 2.958 8.531 3.4 8.2L7.4 5.2C7.746 4.94 8.222 4.933 8.575 5.182L12.575 7.996C13.027 8.314 13.136 8.938 12.818 9.389C12.5 9.84 11.877 9.95 11.425 9.632L8.99716 7.9241C8.99904 7.94916 9 7.97447 9 8V16C9 16.552 8.553 17 8 17C7.447 17 7 16.552 7 16V8.00018L4.6 9.8C4.42 9.935 4.21 10 4.001 10Z"
      fill="#222B45"
    />
  </svg>
);
const ItemsUMOSetUp = (
  <svg
    width="103"
    height="96"
    viewBox="0 0 103 96"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M96.0451 41.3727H90.8882C90.5944 40.3093 89.9624 39.3705 89.0878 38.6981C88.2131 38.0258 87.1433 37.6565 86.0401 37.6461H80.5352V24.1841C80.5414 23.9323 80.4805 23.6833 80.3588 23.4628C80.237 23.2423 80.0588 23.0581 79.8424 22.9291L41.0081 0.49892C40.7893 0.371702 40.5406 0.304687 40.2875 0.304688C40.0343 0.304687 39.7857 0.371702 39.5668 0.49892L0.720476 22.9291C0.500674 23.0565 0.318341 23.2396 0.191854 23.4599C0.0653667 23.6803 -0.000805272 23.9301 7.39606e-06 24.1841V69.0447C1.38584e-05 69.2991 0.0669798 69.549 0.194175 69.7693C0.32137 69.9896 0.504313 70.1725 0.724617 70.2997L39.5749 92.7299C39.7952 92.8571 40.0451 92.9241 40.2995 92.9241C40.5604 92.9242 40.8171 92.8574 41.0448 92.7299L61.4883 80.938V89.4623C61.4862 90.2739 61.6451 91.0778 61.9558 91.8276C62.2665 92.5773 62.7228 93.258 63.2983 93.8302C63.8739 94.4024 64.5572 94.8548 65.3087 95.1611C66.0603 95.4675 66.8651 95.6217 67.6767 95.6149H96.0451C96.8588 95.6224 97.6659 95.469 98.42 95.1634C99.1741 94.8578 99.8604 94.4061 100.439 93.8343C101.018 93.2625 101.478 92.5818 101.793 91.8315C102.108 91.0812 102.271 90.276 102.273 89.4623V47.6213C102.272 45.9679 101.617 44.3822 100.449 43.2111C99.2821 42.0401 97.6985 41.379 96.0451 41.3727ZM86.0917 40.5446C86.6496 40.5446 87.1847 40.7662 87.5792 41.1607C87.9737 41.5552 88.1953 42.0903 88.1953 42.6482V42.7886C88.1953 43.3465 87.9737 43.8816 87.5792 44.2761C87.1847 44.6706 86.6496 44.8922 86.0917 44.8922H77.6701C77.1121 44.8922 76.5771 44.6706 76.1826 44.2761C75.788 43.8816 75.5664 43.3465 75.5664 42.7886V42.6482C75.5664 42.0903 75.788 41.5552 76.1826 41.1607C76.5771 40.7662 77.1121 40.5446 77.6701 40.5446H86.0917ZM40.2995 3.42738L56.4425 12.7475L20.4932 33.5028L4.35036 24.1827L40.2995 3.42738ZM38.9219 88.9646L2.89845 68.2079V26.6911L38.9219 47.4478V88.9646ZM40.2995 44.9378L23.3916 35.176L59.341 14.4209L76.2496 24.1827L40.2995 44.9378ZM61.4883 47.6213V77.5913L41.8203 88.9646V47.4478L77.6367 26.6911V37.6461H77.6817C76.5785 37.6565 75.5087 38.0258 74.634 38.6981C73.7593 39.3704 73.1273 40.3093 72.8336 41.3727H67.6767C66.0274 41.3807 64.4489 42.0435 63.2884 43.2153C62.1278 44.3872 61.4803 45.9721 61.4883 47.6213ZM99.375 89.4623C99.373 89.8955 99.285 90.324 99.116 90.7228C98.947 91.1217 98.7004 91.483 98.3906 91.7858C98.0808 92.0885 97.7139 92.3267 97.3113 92.4865C96.9086 92.6463 96.4782 92.7244 96.0451 92.7164H67.6767C67.2456 92.7237 66.8175 92.6447 66.4174 92.4842C66.0173 92.3237 65.6534 92.0849 65.3469 91.7817C65.0404 91.4786 64.7976 91.1172 64.6327 90.7189C64.4678 90.3206 64.3842 89.8934 64.3867 89.4623V47.6213C64.3824 47.1852 64.464 46.7525 64.6271 46.348C64.7901 45.9435 65.0313 45.5751 65.3369 45.2639C65.6425 44.9528 66.0064 44.7049 66.4079 44.5345C66.8094 44.3642 67.2405 44.2747 67.6767 44.2711H72.8901C73.2009 45.2969 73.8359 46.1944 74.6997 46.8289C75.5636 47.4634 76.6098 47.8009 77.6817 47.7906H86.0401C87.1119 47.8009 88.1582 47.4635 89.022 46.8289C89.8858 46.1944 90.5207 45.2969 90.8315 44.2711H96.0451C96.9301 44.2767 97.7769 44.6321 98.4007 45.2598C99.0246 45.8874 99.3748 46.7363 99.375 47.6213V89.4623Z"
      fill="black"
    />
    <path
      d="M69.2082 62.2852H70.7251C71.1095 62.2852 71.4781 62.1325 71.7499 61.8607C72.0216 61.5889 72.1743 61.2203 72.1743 60.8359C72.1743 60.4516 72.0216 60.083 71.7499 59.8112C71.4781 59.5394 71.1095 59.3867 70.7251 59.3867H70.668V55.4531H74.6651C74.7561 55.7445 74.9401 55.998 75.189 56.1748C75.4379 56.3516 75.7378 56.4418 76.0429 56.4318C76.4277 56.4328 76.7973 56.2812 77.0704 56.0101C77.3436 55.739 77.4981 55.3707 77.5 54.9859V54.0107C77.4967 53.624 77.3411 53.2542 77.0668 52.9816C76.7925 52.709 76.4218 52.5556 76.035 52.5547H69.2082C69.0181 52.5557 68.83 52.5941 68.6548 52.6679C68.4795 52.7416 68.3206 52.8491 68.1869 52.9844C68.0533 53.1196 67.9477 53.2799 67.876 53.456C67.8044 53.6321 67.7682 53.8206 67.7695 54.0107V60.8376C67.7684 61.0273 67.8047 61.2153 67.8765 61.3909C67.9483 61.5664 68.0541 61.726 68.1878 61.8606C68.3215 61.9951 68.4805 62.1019 68.6556 62.1747C68.8307 62.2476 69.0185 62.2851 69.2082 62.2852Z"
      fill="black"
    />
    <path
      d="M69.2188 75.5352H76.0508C76.4351 75.5352 76.8037 75.3825 77.0755 75.1107C77.3473 74.8389 77.5 74.4703 77.5 74.0859V67.2539C77.5 66.8695 77.3473 66.5009 77.0755 66.2292C76.8037 65.9574 76.4351 65.8047 76.0508 65.8047H69.2188C68.8344 65.8047 68.4658 65.9574 68.194 66.2292C67.9222 66.5009 67.7695 66.8695 67.7695 67.2539V74.0859C67.7695 74.4703 67.9222 74.8389 68.194 75.1107C68.4658 75.3825 68.8344 75.5352 69.2188 75.5352ZM70.668 68.7031H74.6016V72.6367H70.668V68.7031Z"
      fill="black"
    />
    <path
      d="M70.7253 85.8867H70.668V81.9531H74.5869C74.5944 82.3342 74.7509 82.6972 75.0229 82.9643C75.295 83.2313 75.6608 83.381 76.042 83.3814C76.4232 83.3818 76.7894 83.2328 77.0619 82.9663C77.3345 82.6998 77.4918 82.3371 77.5 81.956V80.5596C77.4985 80.1678 77.3449 79.7919 77.0716 79.5111C76.7983 79.2304 76.4267 79.0667 76.0351 79.0547H69.2082C68.8193 79.0678 68.451 79.2326 68.1821 79.5138C67.9132 79.7951 67.7651 80.1705 67.7695 80.5596V87.3865C67.7694 87.5736 67.8067 87.7588 67.8795 87.9312C67.9522 88.1037 68.0588 88.2597 68.193 88.3901C68.3272 88.5206 68.4861 88.6228 68.6605 88.6906C68.8349 88.7585 69.0212 88.7906 69.2082 88.7852H70.7253C71.1097 88.7852 71.4783 88.6325 71.7501 88.3607C72.0219 88.0889 72.1746 87.7203 72.1746 87.3359C72.1746 86.9516 72.0219 86.583 71.7501 86.3112C71.4783 86.0394 71.1097 85.8867 70.7253 85.8867Z"
      fill="black"
    />
    <path
      d="M79.3726 54.3314L75.1284 58.5755L73.8374 57.2842C73.7028 57.1497 73.543 57.0429 73.3672 56.9701C73.1914 56.8972 73.0029 56.8598 72.8126 56.8598C72.6223 56.8598 72.4338 56.8972 72.258 56.9701C72.0821 57.0429 71.9223 57.1497 71.7878 57.2842C71.6532 57.4188 71.5464 57.5786 71.4736 57.7544C71.4008 57.9303 71.3633 58.1187 71.3633 58.309C71.3633 58.4994 71.4008 58.6878 71.4736 58.8637C71.5464 59.0395 71.6532 59.1993 71.7878 59.3339L74.1038 61.6497C74.2384 61.7843 74.3982 61.8911 74.574 61.9639C74.7498 62.0367 74.9383 62.0742 75.1286 62.0742C75.319 62.0742 75.5074 62.0367 75.6833 61.9639C75.8591 61.8911 76.0189 61.7843 76.1534 61.6497L81.4228 56.3804C81.6946 56.1086 81.8473 55.7399 81.8473 55.3555C81.8473 54.9712 81.6946 54.6025 81.4228 54.3307C81.151 54.0589 80.7824 53.9063 80.398 53.9062C80.0136 53.9062 79.6444 54.0596 79.3726 54.3314Z"
      fill="black"
    />
    <path
      d="M79.3726 81.0892L75.1284 85.3333L73.8374 84.0421C73.7028 83.9075 73.543 83.8007 73.3672 83.7279C73.1914 83.6551 73.0029 83.6176 72.8126 83.6176C72.6223 83.6176 72.4338 83.6551 72.258 83.7279C72.0821 83.8007 71.9223 83.9075 71.7878 84.0421C71.6532 84.1766 71.5464 84.3364 71.4736 84.5122C71.4008 84.6881 71.3633 84.8765 71.3633 85.0669C71.3633 85.2572 71.4008 85.4456 71.4736 85.6215C71.5464 85.7973 71.6532 85.9571 71.7878 86.0917L74.1038 88.4075C74.2384 88.5421 74.3982 88.6489 74.574 88.7217C74.7498 88.7945 74.9383 88.832 75.1286 88.832C75.319 88.832 75.5074 88.7945 75.6833 88.7217C75.8591 88.6489 76.0189 88.5421 76.1534 88.4075L81.4228 83.1382C81.6946 82.8664 81.8473 82.4977 81.8473 82.1134C81.8473 81.729 81.6946 81.3603 81.4228 81.0886C81.151 80.8168 80.7824 80.6641 80.398 80.6641C80.0136 80.6641 79.6444 80.8174 79.3726 81.0892Z"
      fill="black"
    />
    <path
      d="M94.2391 56.0781H85.1367C84.7524 56.0781 84.3838 56.2308 84.112 56.5026C83.8402 56.7744 83.6875 57.143 83.6875 57.5273C83.6875 57.9117 83.8402 58.2803 84.112 58.5521C84.3838 58.8239 84.7524 58.9766 85.1367 58.9766H94.2391C94.6234 58.9766 94.992 58.8239 95.2638 58.5521C95.5356 58.2803 95.6883 57.9117 95.6883 57.5273C95.6883 57.143 95.5356 56.7744 95.2638 56.5026C94.992 56.2308 94.6234 56.0781 94.2391 56.0781Z"
      fill="black"
    />
    <path
      d="M94.2391 69.3281H85.1367C84.7524 69.3281 84.3838 69.4808 84.112 69.7526C83.8402 70.0244 83.6875 70.393 83.6875 70.7773C83.6875 71.1617 83.8402 71.5303 84.112 71.8021C84.3838 72.0739 84.7524 72.2266 85.1367 72.2266H94.2391C94.6234 72.2266 94.992 72.0739 95.2638 71.8021C95.5356 71.5303 95.6883 71.1617 95.6883 70.7773C95.6883 70.393 95.5356 70.0244 95.2638 69.7526C94.992 69.4808 94.6234 69.3281 94.2391 69.3281Z"
      fill="black"
    />
    <path
      d="M94.2391 82.5781H85.1367C84.7524 82.5781 84.3838 82.7308 84.112 83.0026C83.8402 83.2744 83.6875 83.643 83.6875 84.0273C83.6875 84.4117 83.8402 84.7803 84.112 85.0521C84.3838 85.3239 84.7524 85.4766 85.1367 85.4766H94.2391C94.6234 85.4766 94.992 85.3239 95.2638 85.0521C95.5356 84.7803 95.6883 84.4117 95.6883 84.0273C95.6883 83.643 95.5356 83.2744 95.2638 83.0026C94.992 82.7308 94.6234 82.5781 94.2391 82.5781Z"
      fill="black"
    />
  </svg>
);
const URLAddBtn = (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="16"
    height="16"
    fill="currentColor"
    className="bi bi-plus-lg"
    viewBox="0 0 16 16"
  >
    <path
      fillRule="evenodd"
      d="M8 2a.5.5 0 0 1 .5.5v5h5a.5.5 0 0 1 0 1h-5v5a.5.5 0 0 1-1 0v-5h-5a.5.5 0 0 1 0-1h5v-5A.5.5 0 0 1 8 2"
    />
  </svg>
);
const UpcScanner = (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    lang=".lbiswahitydhtyru;''''''''''''''''''''''''''"
    width="28"
    height="28"
    fill="currentColor"
    className="bi bi-upc-scan"
    viewBox="0 0 16 16"
  >
    <path d="M1.5 1a.5.5 0 0 0-.5.5v3a.5.5 0 0 1-1 0v-3A1.5 1.5 0 0 1 1.5 0h3a.5.5 0 0 1 0 1zM11 .5a.5.5 0 0 1 .5-.5h3A1.5 1.5 0 0 1 16 1.5v3a.5.5 0 0 1-1 0v-3a.5.5 0 0 0-.5-.5h-3a.5.5 0 0 1-.5-.5M.5 11a.5.5 0 0 1 .5.5v3a.5.5 0 0 0 .5.5h3a.5.5 0 0 1 0 1h-3A1.5 1.5 0 0 1 0 14.5v-3a.5.5 0 0 1 .5-.5m15 0a.5.5 0 0 1 .5.5v3a1.5 1.5 0 0 1-1.5 1.5h-3a.5.5 0 0 1 0-1h3a.5.5 0 0 0 .5-.5v-3a.5.5 0 0 1 .5-.5M3 4.5a.5.5 0 0 1 1 0v7a.5.5 0 0 1-1 0zm2 0a.5.5 0 0 1 1 0v7a.5.5 0 0 1-1 0zm2 0a.5.5 0 0 1 1 0v7a.5.5 0 0 1-1 0zm2 0a.5.5 0 0 1 .5-.5h1a.5.5 0 0 1 .5.5v7a.5.5 0 0 1-.5.5h-1a.5.5 0 0 1-.5-.5zm3 0a.5.5 0 0 1 1 0v7a.5.5 0 0 1-1 0z" />
  </svg>
);

const ScannerSuccessLogo = (
  <svg
    width="80"
    height="80"
    viewBox="0 0 120 120"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M113.231 53.9282H113.249C116.509 53.9282 119.16 56.567 119.166 59.8271C119.213 75.6305 113.101 90.5109 101.954 101.717C90.813 112.923 75.974 119.118 60.1706 119.165H59.999C44.2547 119.165 29.4453 113.059 18.2806 101.954C7.07439 90.8127 0.879637 75.9737 0.832304 60.1703C0.784971 44.361 6.89689 29.4864 18.0439 18.2803C29.185 7.07411 44.024 0.879365 59.8274 0.832031C64.5311 0.903031 69.3236 1.37636 73.915 2.47686C77.0863 3.24603 79.0447 6.44103 78.2756 9.61828C77.5123 12.7896 74.2996 14.7421 71.1401 13.9848C67.4658 13.0973 63.5667 12.7245 59.8629 12.6654C47.219 12.7009 35.3442 17.659 26.4337 26.6228C17.5173 35.5865 12.6301 47.4909 12.6656 60.1348C12.7011 72.7787 17.6593 84.6475 26.6231 93.5639C35.5572 102.445 47.4024 107.332 59.999 107.332H60.1351C72.779 107.297 84.6537 102.338 93.5642 93.3746C102.481 84.4049 107.368 72.5065 107.332 59.8626C107.326 56.5966 109.965 53.9341 113.231 53.9282Z"
      fill="#2ED47A"
    />
    <path
      d="M38.0659 55.815C40.3793 53.5016 44.1186 53.5016 46.4321 55.815L59.7091 69.092L96.9663 26.5157C99.12 24.0721 102.853 23.8118 105.315 25.9654C107.77 28.1132 108.019 31.8525 105.865 34.3139L64.4483 81.6472C63.3715 82.8779 61.8331 83.6056 60.1942 83.6648H59.999C58.4311 83.6648 56.9282 83.0435 55.8159 81.9312L38.0659 64.1812C35.7525 61.8678 35.7525 58.1284 38.0659 55.815Z"
      fill="#2ED47A"
    />
    <path
      d="M113.231 53.9282H113.249C116.509 53.9282 119.16 56.567 119.166 59.8271C119.213 75.6305 113.101 90.5109 101.954 101.717C90.813 112.923 75.974 119.118 60.1706 119.165H59.999C44.2547 119.165 29.4453 113.059 18.2806 101.954C7.07439 90.8127 0.879637 75.9737 0.832304 60.1703C0.784971 44.361 6.89689 29.4864 18.0439 18.2803C29.185 7.07411 44.024 0.879365 59.8274 0.832031C64.5311 0.903031 69.3236 1.37636 73.915 2.47686C77.0863 3.24603 79.0447 6.44103 78.2756 9.61828C77.5123 12.7896 74.2996 14.7421 71.1401 13.9848C67.4658 13.0973 63.5667 12.7245 59.8629 12.6654C47.219 12.7009 35.3442 17.659 26.4337 26.6228C17.5173 35.5865 12.6301 47.4909 12.6656 60.1348C12.7011 72.7787 17.6593 84.6475 26.6231 93.5639C35.5572 102.445 47.4024 107.332 59.999 107.332H60.1351C72.779 107.297 84.6537 102.338 93.5642 93.3746C102.481 84.4049 107.368 72.5065 107.332 59.8626C107.326 56.5966 109.965 53.9341 113.231 53.9282Z"
      fill="#2ED47A"
    />
    <path
      d="M38.0659 55.815C40.3793 53.5016 44.1186 53.5016 46.4321 55.815L59.7091 69.092L96.9663 26.5157C99.12 24.0721 102.853 23.8118 105.315 25.9654C107.77 28.1132 108.019 31.8525 105.865 34.3139L64.4483 81.6472C63.3715 82.8779 61.8331 83.6056 60.1942 83.6648H59.999C58.4311 83.6648 56.9282 83.0435 55.8159 81.9312L38.0659 64.1812C35.7525 61.8678 35.7525 58.1284 38.0659 55.815Z"
      fill="#2ED47A"
    />
  </svg>
);
const ScannerWarningLogo = (
  <svg width="86" height="81" viewBox="0 0 86 81" fill="none" xmlns="http://www.w3.org/2000/svg">
<path d="M9.32222 78.1886H76.6778C77.7717 78.1884 78.8469 77.9044 79.7983 77.3643C80.7497 76.8243 81.5447 76.0466 82.1056 75.1074C82.6665 74.1682 82.9741 73.0995 82.9984 72.0058C83.0228 70.9121 82.7629 69.8308 82.2443 68.8676L48.5685 6.32569C46.1795 1.89144 39.8205 1.89144 37.4315 6.32569L3.7557 68.8676C3.23709 69.8308 2.97725 70.9121 3.00156 72.0058C3.02588 73.0995 3.33352 74.1682 3.89443 75.1074C4.45534 76.0466 5.25032 76.8243 6.20169 77.3643C7.15305 77.9044 8.22826 78.1884 9.32222 78.1886Z" stroke="#DFBE47" stroke-width="5" stroke-linecap="round" stroke-linejoin="round"/>
<path d="M41.8658 28.6172L43 52.725L44.1323 28.6271C44.1393 28.473 44.1148 28.3192 44.0603 28.1749C44.0058 28.0306 43.9225 27.899 43.8154 27.788C43.7083 27.6771 43.5797 27.5891 43.4375 27.5295C43.2952 27.4699 43.1424 27.44 42.9881 27.4415C42.8366 27.4429 42.687 27.4748 42.548 27.535C42.4089 27.5953 42.2834 27.6829 42.1788 27.7925C42.0742 27.902 41.9926 28.0315 41.9388 28.1731C41.885 28.3148 41.8602 28.4658 41.8658 28.6172Z" stroke="#DFBE47" stroke-width="5" stroke-linecap="round" stroke-linejoin="round"/>
<path d="M42.9997 68.5058C42.2181 68.5058 41.454 68.274 40.804 67.8397C40.1541 67.4054 39.6476 66.7882 39.3484 66.0661C39.0493 65.3439 38.9711 64.5493 39.1235 63.7826C39.276 63.016 39.6524 62.3118 40.2052 61.7591C40.7579 61.2064 41.4621 60.83 42.2287 60.6775C42.9953 60.525 43.79 60.6033 44.5121 60.9024C45.2343 61.2015 45.8515 61.7081 46.2858 62.358C46.72 63.0079 46.9518 63.772 46.9518 64.5537C46.9518 65.6018 46.5354 66.6071 45.7943 67.3482C45.0531 68.0894 44.0479 68.5058 42.9997 68.5058Z" fill="#DFBE47"/>
</svg>
);
const RoundTik = (
  <svg
    width="20"
    height="20"
    viewBox="0 0 32 31"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <circle
      cx="15.5"
      cy="15.5"
      r="13.5"
      transform="matrix(1.19249e-08 -1 -1 -1.19249e-08 31.5938 31)"
      stroke="#F0F0F0"
      stroke-width="4"
    />
    <mask id="path-2-inside-1_10480_235561" fill="white">
      <path d="M16.0938 -1.84836e-07C7.53334 -2.86918e-07 0.59375 6.93959 0.59375 15.5C0.59375 24.0604 7.53334 31 16.0938 31C24.6542 31 31.5938 24.0604 31.5938 15.5C31.5938 6.93959 24.6542 -8.27537e-08 16.0938 -1.84836e-07ZM16.0938 27.0319C9.72486 27.0319 4.56185 21.8689 4.56185 15.5C4.56185 9.13111 9.72486 3.9681 16.0938 3.9681C22.4626 3.9681 27.6256 9.13111 27.6256 15.5C27.6256 21.8689 22.4626 27.0319 16.0938 27.0319Z" />
    </mask>
    <path
      d="M16.0938 -1.84836e-07C7.53334 -2.86918e-07 0.59375 6.93959 0.59375 15.5C0.59375 24.0604 7.53334 31 16.0938 31C24.6542 31 31.5938 24.0604 31.5938 15.5C31.5938 6.93959 24.6542 -8.27537e-08 16.0938 -1.84836e-07ZM16.0938 27.0319C9.72486 27.0319 4.56185 21.8689 4.56185 15.5C4.56185 9.13111 9.72486 3.9681 16.0938 3.9681C22.4626 3.9681 27.6256 9.13111 27.6256 15.5C27.6256 21.8689 22.4626 27.0319 16.0938 27.0319Z"
      stroke="#48D2A0"
      stroke-width="4"
      mask="url(#path-2-inside-1_10480_235561)"
    />
    <path
      d="M14.4036 22.436C14.1366 22.436 13.8864 22.3359 13.7028 22.1524L9.33136 17.6474C8.91424 17.2637 8.89758 16.613 9.29796 16.1959C9.68168 15.7788 10.3324 15.7621 10.7495 16.1625L13.953 18.4483C14.1366 18.6152 14.4202 18.5818 14.5703 18.3816L22.162 9.00467C22.4957 8.55414 23.1464 8.45406 23.5969 8.80448C24.0474 9.13815 24.1475 9.78887 23.7971 10.2394L15.221 22.019C15.0375 22.2525 14.7705 22.4027 14.4869 22.4194C14.4536 22.4361 14.4368 22.4361 14.4035 22.4361L14.4036 22.436Z"
      fill="#48D2A0"
    />
  </svg>
);

const WatchIcon = (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="16"
    height="16"
    fill="currentColor"
    className="bi bi-stopwatch"
    viewBox="0 0 16 16"
  >
    <path d="M8.5 5.6a.5.5 0 1 0-1 0v2.9h-5a.5.5 0 0 1 0 1H8a.5.5 0 0 0 .5-.5z" />
    <path d="M6.5 1A.5.5 0 0 1 7 .5h2a.5.5 0 0 1 0 1v.57c1.36.196 2.594.78 3.584 1.64l.012-.013.354-.354-.354-.353a.5.5 0 0 1 .707-.708l1.414 1.415a.5.5 0 1 1-.707.707l-.353-.354-.354.354-.013.012A7 7 0 1 1 7 2.071V1.5a.5.5 0 0 1-.5-.5M8 3a6 6 0 1 0 .001 12A6 6 0 0 0 8 3" />
  </svg>
);

const EnterIcon = (
  <svg
    width="16"
    height="16"
    viewBox="0 0 16 16"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M1 8C1 7.447 1.447 7 2 7H10.293L6.146 3.854C5.951 3.659 5.951 3.341 6.146 3.146C6.341 2.951 6.659 2.951 6.854 3.146L12.854 9.146C13.049 9.341 13.049 9.659 12.854 9.854L6.854 15.854C6.659 16.049 6.341 16.049 6.146 15.854C5.951 15.659 5.951 15.341 6.146 15.146L10.293 11H2C1.447 11 1 10.553 1 10V8Z"
      fill="#222B45"
    />
  </svg>
);

const RoundIcon = (
  <svg
    width="20"
    height="20"
    viewBox="0 0 32 32"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <circle cx="16" cy="16" r="15" stroke="#F0F0F0" stroke-width="4" />
    <path
      d="M16 1 A15 15 0 0 1 17.45 1.55"
      stroke="#48D2A0"
      stroke-width="4"
      fill="none"
    />
  </svg>
);

const ArrowReturnLeft = (
  <svg
    width="24"
    height="12"
    viewBox="0 0 24 12"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M22.1777 1.52502C21.9926 1.5272 21.8158 1.60278 21.6865 1.73524C21.557 1.86771 21.4856 2.04615 21.4878 2.2313V5.28281L2.7806 5.28297L5.8611 1.77299C5.98796 1.63321 6.05294 1.44791 6.04094 1.25951C6.02894 1.07094 5.94121 0.895307 5.79752 0.772665C5.65399 0.65002 5.46683 0.590799 5.27872 0.608565C5.09857 0.626175 4.93245 0.713289 4.8151 0.851207L0.717476 5.52013C0.710308 5.52902 0.703762 5.53821 0.697061 5.5474C0.684127 5.56361 0.671816 5.58044 0.660283 5.59789C0.657945 5.60101 0.655764 5.60413 0.653426 5.6074C0.642205 5.62595 0.631608 5.64511 0.622102 5.66459C0.612596 5.68283 0.604024 5.70153 0.596232 5.72054C0.593895 5.72646 0.591557 5.73223 0.589375 5.73815C0.583298 5.75529 0.577843 5.77259 0.573012 5.79004C0.572077 5.79269 0.571142 5.7955 0.570362 5.7983C0.566155 5.81358 0.562571 5.829 0.559454 5.84459C0.556025 5.8622 0.55322 5.87997 0.551194 5.89773C0.548701 5.92079 0.547298 5.94402 0.547142 5.96724C0.546519 5.98999 0.546986 6.01274 0.548545 6.03549V6.03814C0.550571 6.06058 0.553843 6.08287 0.558051 6.105C0.580492 6.22811 0.635503 6.34312 0.717631 6.43772C0.725112 6.44644 0.732748 6.45501 0.740695 6.46359L4.81518 11.1066C4.93487 11.2552 5.10988 11.3481 5.29999 11.3643C5.48996 11.3805 5.67821 11.3184 5.82126 11.1921C5.96416 11.0659 6.04925 10.8868 6.05689 10.6962C6.06437 10.5056 5.99362 10.3203 5.86115 10.1834L2.78612 6.67916H22.1887C22.3738 6.67838 22.5512 6.60404 22.6816 6.47267C22.812 6.34114 22.8848 6.16333 22.8842 5.97817V2.23129C22.8864 2.04334 22.8127 1.86241 22.6797 1.72949C22.5468 1.59656 22.3658 1.52283 22.1777 1.52502Z"
      fill="white"
      stroke="white"
      stroke-width="0.5"
    />
  </svg>
);
const RedirectIcon = (
  <svg width="12" height="12" viewBox="0 0 18 18" fill="none" xmlns="http://www.w3.org/2000/svg">
<path d="M17 8C16.7348 8 16.4804 8.10536 16.2929 8.29289C16.1054 8.48043 16 8.73478 16 9V15C16 15.2652 15.8946 15.5196 15.7071 15.7071C15.5196 15.8946 15.2652 16 15 16H3C2.73478 16 2.48043 15.8946 2.29289 15.7071C2.10536 15.5196 2 15.2652 2 15V3C2 2.73478 2.10536 2.48043 2.29289 2.29289C2.48043 2.10536 2.73478 2 3 2H9C9.26522 2 9.51957 1.89464 9.70711 1.70711C9.89464 1.51957 10 1.26522 10 1C10 0.734784 9.89464 0.48043 9.70711 0.292893C9.51957 0.105357 9.26522 0 9 0H3C2.20435 0 1.44129 0.316071 0.87868 0.87868C0.316071 1.44129 0 2.20435 0 3V15C0 15.7956 0.316071 16.5587 0.87868 17.1213C1.44129 17.6839 2.20435 18 3 18H15C15.7956 18 16.5587 17.6839 17.1213 17.1213C17.6839 16.5587 18 15.7956 18 15V9C18 8.73478 17.8946 8.48043 17.7071 8.29289C17.5196 8.10536 17.2652 8 17 8Z" fill="#29afe8"/>
<path d="M12.9999 2H14.5799L8.28994 8.28C8.19621 8.37296 8.12182 8.48356 8.07105 8.60542C8.02028 8.72728 7.99414 8.85799 7.99414 8.99C7.99414 9.12201 8.02028 9.25272 8.07105 9.37458C8.12182 9.49644 8.19621 9.60704 8.28994 9.7C8.3829 9.79373 8.4935 9.86812 8.61536 9.91889C8.73722 9.96966 8.86793 9.9958 8.99994 9.9958C9.13195 9.9958 9.26266 9.96966 9.38452 9.91889C9.50638 9.86812 9.61698 9.79373 9.70994 9.7L15.9999 3.42V5C15.9999 5.26522 16.1053 5.51957 16.2928 5.70711C16.4804 5.89464 16.7347 6 16.9999 6C17.2652 6 17.5195 5.89464 17.707 5.70711C17.8946 5.51957 17.9999 5.26522 17.9999 5V1C17.9999 0.734784 17.8946 0.48043 17.707 0.292893C17.5195 0.105357 17.2652 0 16.9999 0H12.9999C12.7347 0 12.4804 0.105357 12.2928 0.292893C12.1053 0.48043 11.9999 0.734784 11.9999 1C11.9999 1.26522 12.1053 1.51957 12.2928 1.70711C12.4804 1.89464 12.7347 2 12.9999 2Z" fill="#29afe8"/>
</svg>

);

const getProgressCircle=(total:any,achived:any)=> {
  let percentage= Math.round((parseFloat(achived)/parseFloat(total)) * 100)??0;
  let _percentage = percentage;
  console.log(percentage,"percentage is");
  percentage = Math.max(0, Math.min(100, percentage));
  const radius = 15;
  const circumference = 2 * Math.PI * radius;
  const strokeDasharray = circumference;
  const strokeDashoffset = circumference - (percentage / 100) * circumference;
  const color =(_percentage >100 )?'#df604f':'#48D2A0';
  console.log(color,percentage,"color is");

  return percentage?(
      <svg
          width="20"
          height="20"
          viewBox="0 -5 30 40"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
      >
          <circle
              cx="16"
              cy="16"
              r={radius}
              stroke="#F0F0F0"
              stroke-width="4"
              fill="none"
          />
          <circle
              cx="16"
              cy="16"
              r={radius}
              stroke={color}
              stroke-width="4"
              fill="none"
              stroke-dasharray={strokeDasharray}
              stroke-dashoffset={strokeDashoffset}
              transform="rotate(-90 16 16)"
          />
      </svg>):(<></>)
}


const GetSvgIcon: SVGIconType = {
  GlobalSearchIcon,
  GlobalFilter,
  GlobalDownArrow,
  GlobalUpArrow,
  ItemsUMOSetUp,
  ModalUploadFile,
  URLAddBtn,
  UpcScanner,
  ScannerSuccessLogo,
  RoundTik,
  WatchIcon,
  EnterIcon,
  RoundIcon,
  ArrowReturnLeft,
  ScannerWarningLogo,
  RedirectIcon,
  getProgressCircle,
};

export default GetSvgIcon;
